export default import.meta.ROLLUP_FILE_URL_ChLstykuCSWTQ4swzruRDA